import { generateAvatarList } from './generator'

/**
 * Avatar list for main users.
 * Currently uses the default avatar path, but can be customized in the future
 * when main-user-specific assets are available.
 *
 * To customize when assets are ready:
 * generateAvatarList({ pathPrefix: 'avatar/main/', includeLegacyIds: true })
 */
export const mainUserAvatarList = generateAvatarList({
  includeLegacyIds: true,
})
